import styled from 'styled-components';

export const ButtonFlex = styled.div`
	height: 100%;
	display: flex;
	gap: 24px;
	align-items: center;
`;
